module.exports = __webpack_public_path__ + "img/settings.2f86a319.svg";